import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_vendorperformance-list.scss'

const VendorPerformance = () => {
    return (
        <div className='vendorPerformance'>
            <PageTitle
                title="Vendor Performance"
                subtitle="Your Key Performance Indicator"
            />

            <div className="row w-100">
                <div className="col-md-4 col-lg-4">
                    <div className="card w-100 rounded-0 vendor-card">
                        <div className="card-content">
                            <div className='d-flex justify-content-between'>
                                <span className='fs-4'>Average Food Preparation <br /> Time</span>
                                <i className='mdi mdi-information-outline mdi-18px mr-4'> </i>
                            </div>
                            <div className="d-flex  align-item-center justify-content-between">
                                <span className='fs-1'>11min</span>
                                <div>
                                    <p className='text-red m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i> 1min(10.00%) </p>
                                    <p>from 7 days ago</p>
                                </div>
                                <i className='mdi mdi-chevron-right mdi-48px' style={{ color: '#398ec0' }}> </i>
                            </div>
                        </div>
                    </div>
                    <div className="vendor-card-footer card rounded-0 ">
                        <span className='footer-text'>Wow. your food prep time amazing. We have got nothing more to say</span>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="card w-100 rounded-0 vendor-card">
                        <div className="row card-content d-flex align-items-center">
                            <div className="col-md-10 col-lg-10">
                                <div className="d-flex">
                                    <span className='fs-4'>Order Revenue Loss</span>
                                    <i className='mdi mdi-information-outline mdi-18px ml-2'> </i>
                                </div>
                                <div className="d-flex  align-item-center justify-content-between">
                                    <span className='fs-1'>Rs4,800</span>
                                    <div>
                                        <p className='text-red m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i> 1min(10.00%) </p>
                                        <p>from 7 days ago</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <small>Restaurant Order Rejection Rate </small>
                                    <i className='mdi mdi-information-outline mdi-18px ml-2'> </i>
                                </div>

                                <div className="d-flex  align-item-center">
                                    <span className='fs-4'>1.09%</span>
                                    <div>
                                        <p className='m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i>2.01(68.84%) </p>
                                        <p> <small> from 7 days ago </small> </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 col-lg-2 vendor-card-icon">
                                <i className='mdi mdi-chevron-right mdi-48px pr-3' style={{ color: '#398ec0' }}> </i>
                            </div>
                        </div>
                    </div>
                    <div className="vendor-card-footer card rounded-0 ">
                        <span className='footer-text'>Wow. your food prep time amazing. We have got nothing more to say</span>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="card w-100 rounded-0 vendor-card">
                        <div className="row card-content d-flex align-items-center">
                            <div className="col-md-10 col-lg-10">
                                <div className="d-flex">
                                    <span className='fs-4'>Offline Duration during opening hours</span>
                                    <i className='mdi mdi-information-outline mdi-18px ml-4'> </i>
                                </div>
                                <div className="d-flex  align-item-center justify-content-between">
                                    <span className='fs-1'>2h 0m</span>
                                    <div>
                                        <p className='text-red m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i> 3h 0m(60.00%) </p>
                                        <p>from 7 days ago</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <small>Restaurant Offline duration % </small>
                                    <i className='mdi mdi-information-outline mdi-18px ml-2'> </i>
                                </div>

                                <div className="d-flex  align-item-center">
                                    <span className='fs-4'>3%</span>
                                    <div>
                                        <p className='m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i>1%(25.00%) </p>
                                        <p> <small> from 7 days ago </small> </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 col-lg-2 vendor-card-icon">
                                <i className='mdi mdi-chevron-right mdi-48px' style={{ color: '#398ec0' }}> </i>
                            </div>
                        </div>
                    </div>
                    <div className="vendor-card-footer card rounded-0 ">
                        <span className='footer-text'>Wow. your food prep time amazing. We have got nothing more to say</span>
                    </div>
                </div>
            </div>
            <div className="row w-100">
                <div className="col-md-4 col-lg-4">
                    <div className="card w-100 rounded-0 vendor-card">
                        <div className="card-content">
                            <div className='d-flex justify-content-between'>
                                <span className='fs-4'>Average Restaurant <br /> Acceptance Time</span>
                                <i className='mdi mdi-information-outline mdi-18px mr-4'> </i>
                            </div>
                            <div className="d-flex  align-item-center justify-content-between mt-1">
                                <span className='fs-1'>16s</span>
                                <div>
                                    <p className='text-red m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i> 1s(6.67%) </p>
                                    <p>from 7 days ago</p>
                                </div>

                                <i className='mdi mdi-chevron-right mdi-48px' style={{ color: '#398ec0' }}> </i>
                            </div>
                        </div>
                    </div>
                    <div className="vendor-card-footer card rounded-0 ">
                        <span className='footer-text'>Wow. your food prep time amazing. We have got nothing more to say</span>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="card w-100 rounded-0 vendor-card">
                        <div className="card-content">
                            <span className='fs-4'>Restaurant Delay Rate </span>
                            <i className='mdi mdi-information-outline mdi-18px'> </i>
                            <div className="d-flex  align-item-center justify-content-between mt-1">
                                <span className='fs-1'>19%</span>
                                <div>
                                    <p className='text-red m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i> 1%(5.56%) </p>
                                    <p>from 7 days ago</p>
                                </div>
                                <i className='mdi mdi-chevron-right mdi-48px' style={{ color: '#398ec0' }}> </i>
                            </div>
                        </div>
                    </div>
                    <div className="vendor-card-footer card rounded-0 ">
                        <span className='footer-text'>Wow. your food prep time amazing. We have got nothing more to say</span>
                    </div>
                </div>
                <div className="col-md-4 col-lg-4">
                    <div className="card w-100 rounded-0 vendor-card">
                        <div className="row card-content d-flex align-items-center">
                            <div className="col-md-10 col-lg-10">
                                <div className="d-flex">
                                    <span className='fs-4'>Customer Conversion</span>
                                    <i className='mdi mdi-information-outline mdi-18px ml-4'> </i>
                                </div>
                                <div className="d-flex  align-item-center justify-content-between">
                                    <span className='fs-1'>24.6%</span>
                                    <div>
                                        <p className='text-red m-0 p-0'> <i className='mdi mdi-chart-line-variant'></i> 12.0%(95.24%) </p>
                                        <p>from 7 days ago</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <small>customer view </small>
                                    <i className='mdi mdi-information-outline mdi-18px ml-2'> </i>
                                </div>
                                <span className='fs-4'>6898</span>
                                <small> from 7 days ago </small>
                            </div>
                            <div className="col-md-2 col-lg-2 vendor-card-icon">
                                <i className='mdi mdi-chevron-right mdi-48px' style={{ color: '#398ec0' }}> </i>
                            </div>
                        </div>
                    </div>
                    <div className="vendor-card-footer card rounded-0 ">
                        <span className='footer-text'>Wow. your food prep time amazing. We have got nothing more to say</span>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default VendorPerformance;